import { Divider } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import {
  Area,
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  AreaChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
  ComposedChart,
  Line,
} from "recharts";
import IntlMessages from "../../util/IntlMessages";
import { formatDigits } from "../../appRedux/actions";

const LineChart = (props) => {
  const getDefaultDecimalPlaces = useSelector(
    ({ MainSale }) => MainSale.getDefaultDecimalPlaces
  );

  const currencySymbol = props.currency ? props.currency : "";
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div class="vd-popover vd-chart-popover vd-popover--tooltip">
          <div class="vd-popover-content vd-align-center">
            <div>
              <div class="dk-text-label">
                {payload[0].payload.PeriodDateToolTip}
              </div>
              <div class="dk-text-label">
                {currencySymbol}&nbsp;
                {formatDigits(
                  payload[0].payload.PeriodValue,
                  getDefaultDecimalPlaces
                )}
              </div>
            </div>
            <Divider className="dk-divider-white" />
            <div>
              <div class="dk-text-supplementary">
                {payload[0].payload.PrevPeriodDateToolTip}
              </div>
              <div class="dk-text-supplementary">
                {currencySymbol}&nbsp;{" "}
                {formatDigits(
                  payload[0].payload.PreviousPeriodValue,
                  getDefaultDecimalPlaces
                )}
              </div>
            </div>
          </div>
          <div class="vd-popover-beak"></div>
        </div>
      );
    }

    return null;
  };
  return (
    <ResponsiveContainer width="90%" height={180}>
      <AreaChart
        data={props.data}
        margin={{ top: 0, right: 20, left: 20, bottom: 20 }}
      >
        <Tooltip content={<CustomTooltip />} />
        <XAxis
          dataKey="PeriodDate"
          interval={props.chartInterval}
          angle={45}
          dx={15}
          dy={20}
          axisLine={false}
          minTickGap={-200}
        />
        <YAxis />
        <defs>
          <linearGradient id="color15" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#979899" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#979899" stopOpacity={0.8} />
          </linearGradient>

          {/* Blue "#0c4f8e" ; Green : "#6ecf79"  */}
          <linearGradient id="color16" x1="0" y1="0" x2="0" y2="1" >
            <stop offset="5%" stopColor="#0c4f8e" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#0c4f8e" stopOpacity={0.8} />
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" />
        {/* Grey */}
        <Area
          dataKey="PreviousPeriodValue"
          strokeWidth={2}
          stackId="2"
          stroke="#353739"
          fill="url(#color15)"
          fillOpacity={1}
          dot={true}
        />

        {/* Blue : "#0c4f8e"  ; Green : "#009d12" */}
        <Area
          dataKey="PeriodValue"
          strokeWidth={2}
          stackId="2"
          stroke="#0c4f8e"
          fill="url(#color16)"
          fillOpacity={1}
          dot={true}
        />
      </AreaChart>
    </ResponsiveContainer>
  );
};

export default LineChart;
